import { MaybeRefOrGetter, useTimeoutFn } from '@vueuse/core';

export function useDelayedLoading(dependency: MaybeRefOrGetter<boolean>, delayMs: number) {
  const isLoading = ref(false);

  const { stop, start } = useTimeoutFn(() => {
    isLoading.value = true;
  }, delayMs);

  watchEffect(() => {
    if (toValue(dependency)) {
      start();
    } else {
      stop();
      isLoading.value = false;
    }
  });

  return { isLoading };
}
